function asInputRef(renderResult) {
  const { ref, ...rest } = renderResult;
  return {
    inputRef: ref,
    ...rest
  };
}
function getCatalogFilename(config) {
  return config.getOptionalString("catalog.import.entityFilename") ?? "catalog-info.yaml";
}
function getBranchName(config) {
  return config.getOptionalString("catalog.import.pullRequestBranchName") ?? "backstage-integration";
}

export { asInputRef, getBranchName, getCatalogFilename };
//# sourceMappingURL=helpers.esm.js.map
